var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.teatro.sga === 1)?_c('PerfilSga'):(_vm.manager.lfp === 1)?_c('Perfil'):(_vm.usaPerfilAntiguo)?_c('Perfil'):_c('PerfilV2')
}
var staticRenderFns = []

export { render, staticRenderFns }